import { useMemo } from 'react'
import { connect } from 'react-redux';
import {
  LockedLabel
} from './styles'
import Icon from '../../../../../components/Icon';
import padlockLockIcon from '../../../../../assets/icons/padlock-lock.svg'
import { CategoryDto } from '../../../../../types/category';
import { isSubscribed } from '../../../../../helpers/isSubscribed';
import { Group, User } from '../../../../../types';
import { isOwnGroup } from '../../../../../helpers/isOwnGroup';
import { roundedHumanUnlockTime } from '../../../../../helpers/humanUnlockTime';
import { CSSProp, CSSProperties } from 'styled-components';


interface ComponentProps {
  category: CategoryDto
  subscriptions
  group: Group
  user: User
  style: CSSProperties
}

const CategoryHeader = ({
  category,
  subscriptions,
  group,
  user,
  style
}: ComponentProps) => {

  const showBadge = useMemo(() => {
    return (isSubscribed(subscriptions, group?.id) || isOwnGroup({ group, expertId: user?.expert?.id })) && category?.is_unlockable
  }, [subscriptions, group, category])

  const humanReadableTime = useMemo(() => {
    return roundedHumanUnlockTime(category)
  }, [category]);

  return showBadge ? (
    <div style={style}>
      <LockedLabel>
        {!category?.user_access_data?.is_unlocked && <Icon icon={padlockLockIcon} size="16px" color="#93410F" />}
        {humanReadableTime}
      </LockedLabel>
    </div>
  ) : (<></>)
}

const state = ({ userStore, postStore, groupStore, categoryStore, preferencesStore }) => {
  const { data: category, states: categoryState } =
    categoryStore.singleCategory;
  const { data: subscriptions, states: subscriptionsStates } =
    userStore.subscriptions;
  const { data: user, states: userStates } =
    userStore.information;
  const { data: group, states: groupStates } = groupStore.group;

  return {
    subscriptions,
    subscriptionsStates,
    user,
    userStates,
    category,
    categoryState,
    group,
    groupStates
  };
};

export default connect(state)(CategoryHeader);